// extracted by mini-css-extract-plugin
export default {"download":"Download_download__P57Pj","cards":"Download_cards__yg6vg"};